var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.4998 32.0833C10.6252 32.0833 7.18786 32.0833 5.05219 29.9476C2.9165 27.812 2.9165 24.3745 2.9165 17.5C2.9165 10.6253 2.9165 7.18798 5.05219 5.05231C7.18786 2.91663 10.6252 2.91663 17.4998 2.91663C24.3744 2.91663 27.8119 2.91663 29.9474 5.05231C32.0832 7.18798 32.0832 10.6253 32.0832 17.5C32.0832 24.3745 32.0832 27.812 29.9474 29.9476C27.8119 32.0833 24.3744 32.0833 17.4998 32.0833Z",
    fill: "#71717a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0806 13.0807C13.5077 12.6536 14.2003 12.6536 14.6274 13.0807L17.4998 15.9532L20.3723 13.0808C20.7995 12.6536 21.4919 12.6536 21.919 13.0808C22.3462 13.5079 22.3462 14.2004 21.919 14.6275L19.0467 17.5L21.919 20.3724C22.3462 20.7994 22.3462 21.492 21.919 21.9191C21.4919 22.3463 20.7993 22.3463 20.3722 21.9191L17.4998 19.0468L14.6275 21.9191C14.2003 22.3463 13.5078 22.3463 13.0806 21.9191C12.6535 21.492 12.6535 20.7996 13.0806 20.3724L15.9531 17.5L13.0806 14.6275C12.6535 14.2004 12.6535 13.5079 13.0806 13.0807Z",
    fill: "#71717a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWindow);
export default __webpack_public_path__ + "static/media/close_window.7a78d253b8a51bb71513104b176f5703.svg";
export { ForwardRef as ReactComponent };